import Vue from "vue";
import ElementUI from "element-ui";
import "./assets/element-xt-theme/index.css";
import App from "./App.vue";

import router from "./router";
import axios from "axios";
Vue.config.productionTip = false;
Vue.use(ElementUI);

axios.interceptors.response.use(
  response => {
    if (response.data.StatusCode === 403) {
      //token验证不通过
      localStorage.removeItem("TOKEN");
      localStorage.removeItem("user");
      localStorage.removeItem("openid");
      localStorage.removeItem("_uuid");
      // Vue.prototype.$message({
      //   message: "请求验证未通过，请重新登录",
      //   type: "error"
      // });
      //当前页url与参数放入params然后跳转到登录
      router.replace({
        path: "/login",
        query: { return_url: router.currentRoute.fullPath }
      });
    }
    return response;
  },
  error => {
    if (axios.isCancel(error)) {
      // 为了终结promise链 就是实际请求 不会走到.catch(rej=>{});这样就不会触发错误提示之类了。
      return new Promise(() => {});
    } else {
      if (error.response.status === 500) {
        Vue.prototype.$alert("网络异常，请刷新页面重试", "出错啦", {
          confirmButtonText: "刷新",
          callback: () => {
            window.location.reload();
          }
        });
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  }
);
// http response 拦截器
const CancelToken = axios.CancelToken;
let store = { _axiosPromiseCancel: [] };
// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 这个是取消重点
    config.cancelToken = new CancelToken(cancel => {
      store._axiosPromiseCancel.push(cancel);
    });
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
router.beforeEach((to, from, next) => {
  //跳转页面取消上页面的ajax
  store._axiosPromiseCancel.forEach(e => {
    e && e();
  });
  store._axiosPromiseCancel = [];
  if (to.meta.content) {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  const _uuid = localStorage.getItem("_uuid");
  //浏览器端
  if (to.matched.some(record => record.meta.requiresAuth)) {
    //这里判断用户是否登录
    if (!_uuid) {
      if (to.name === "login") {
        next();
        return;
      }
      next({
        path: "/login",
        query: { return_url: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
import { Common } from "./model/common";

//混入设置用户信息的功能
Vue.mixin({
  data: function() {
    return {
      user: ""
    };
  },
  methods: {
    setUser() {
      let user = localStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
        this.user = user;
      }
    },
    checkUserLogin() {
      let _this = this;
      return new Promise(function(resolve, reject) {
        if (!_this.user) {
          router.push({
            path: "/login",
            query: { return_url: router.currentRoute.fullPath }
          });
          return;
        }
        if (!_this.user.phone) {
          _this.$message({
            message: "您还没有绑定手机号哦",
            type: "error"
          });
          reject();
          return;
        }
        resolve();
      });
    },
    //艺术家关注
    addLike(id) {
      let _this = this;
      let common = new Common();
      return new Promise(function(resolve, reject) {
        _this
          .checkUserLogin()
          .then(
            () => {
              common
                .addUserLike({
                  like_type: 2,
                  object_id: id,
                  customer_id: _this.user.id,
                  union_id: _this.user.union_id
                })
                .then(
                  function() {
                    resolve();
                  },
                  () => {
                    reject();
                    console.log("来自mixin：添加失败了");
                  }
                );
            },
            () => {}
          )
          .catch(error => {
            throw new Error(error);
          });
      });
    }
  },
  created() {
    this.setUser();
  },
  beforeRouteLeave(to, from, next) {
    next(); // next()记得写不然不跳转
  }
});
new Vue({
  render: h => h(App),
  router
}).$mount("#app");
